/* eslint-disable no-magic-numbers , complexity */
import { Logger } from '@futrli/shared-services';

import { businessTypeMetaData, INTERNAL_BUSINESS_TYPE, METADATA_FIELD } from './constants';
import { getPendoVisitorId, isInternalUser, isPendoReady, isPendoTempId } from './utils';

// Function to initialize Pendo with user-specific information
export const initializePendoUser = (userId: string, email: string, businessType: string) => {
  // Ensure pendo is loaded
  if (!window.pendo || typeof window.pendo.initialize !== 'function') {
    Logger.warn('[Pendo Debug] Pendo is not ready to initialize the user.');
    return;
  }

  Logger.info('[Pendo Debug] Initializing Pendo user');
  window.pendo.initialize({
    visitor: {
      id: userId,
      [METADATA_FIELD.BUSINESS_TYPE]: isInternalUser(email)
        ? INTERNAL_BUSINESS_TYPE
        : businessTypeMetaData[businessType] || INTERNAL_BUSINESS_TYPE
    }
  });
};

// Function to re-initialize Pendo user
export const reInitializePendoUser = async (userId: string, email: string, businessType: string) => {
  if (!isPendoReady()) {
    Logger.warn('[Pendo Debug] Pendo is not ready to re initialize the user.');
    return;
  }

  try {
    if (typeof window.pendo?.clearSession === 'function') {
      window.pendo.clearSession();
    }

    // Initialize Pendo
    window.pendo.initialize({
      visitor: {
        id: userId,
        [METADATA_FIELD.BUSINESS_TYPE]: isInternalUser(email)
          ? INTERNAL_BUSINESS_TYPE
          : businessTypeMetaData[businessType] || INTERNAL_BUSINESS_TYPE
      }
    });

    // Add a short delay for Pendo changes to propagate
    await new Promise(resolve => setTimeout(resolve, 500));

    // Update options if the visitor ID is still a dummy Pendo ID
    const visitorIdAfterInit = getPendoVisitorId();
    if (isPendoTempId(visitorIdAfterInit || '')) {
      Logger.info('[Pendo Debug] Dummy visitor ID detected. Updating options...');
      window.pendo.updateOptions({
        visitor: {
          id: userId,
          [METADATA_FIELD.BUSINESS_TYPE]: isInternalUser(email)
            ? INTERNAL_BUSINESS_TYPE
            : businessTypeMetaData[businessType] || INTERNAL_BUSINESS_TYPE
        }
      });
    }
  } catch (error) {
    Logger.info('[Pendo Debug] Error during Pendo reinitialization');
  }
};
